<template>
    <div class="row">
        <section class="w-100 slider-container">
            <slider animation="fade" height="485px" :interval="6000" :speed="100">
                <slider-item v-for="(i, index) in list" :key="index">
                    <div :style="_buildCSSForSlideItem(index)" class="ss__slider-item">
                        <div class="ss_content__slider-item">
                            <h1>{{ i.title }}</h1>
                            <div v-if="i.html" v-html="i.html"></div>
                        </div>
                    </div>
                </slider-item>
            </slider>
        </section>

        <section class="w-100 features-sections container">
            <h1 class="title">Основные функции </h1>
            <h2 class="sub-title">Мы разработали их максимально простыми<br/> и эффективными</h2>

            <div class="media-container-row row">
                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__rocket.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Мгновенный запуск</h1>
                                <p class="mbr-text mb-0">
                                    Удобный и понятный интерфейс позволит начать полноценную работу с сервисом уже в течении нескольких минут.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__unique_design.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Стилизация и брендирование</h1>
                                <p class="mbr-text mb-0">
                                    Возможность применения собственных фирменных цветов а также логотипов в интерфейсе платформы. В результате, каждый пользователь получает уникальный и неповторимый дизайн.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="media-container-row row">
                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__user.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Быстрое обучение</h1>
                                <p class="mbr-text mb-0">
                                    С помощью этой простой, эффективной и понятной программы Ваши новые сотрудники смогут быстро и качественно использовать её буквально за первые часы работы с ней.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss_personal_cabinet.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Личный кабинет клиента</h1>
                                <p class="mbr-text mb-0">
                                    Каждый клиент имеет доступ к своему личному кабинету, с помощью которого он может посмотреть свою тренировочную программу, график посещений и динамику прогресса с помощью собственных антропометрических данных, лицевой счет а также сроки истекающих абонементов.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="media-container-row row">
                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__fb.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Современная система управления</h1>
                                <p class="mbr-text mb-0">
                                    Многофункциональная программа позволит Вам следить за качеством предоставляемого сервиса. А также налаженная система отзывов клиентов позволяет контролировать работу каждого тренера и клуба в целом. Все это способствует привлечению, удержанию и привязке клиентов к залам и спорт центрам.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__report.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Удобная система формирования отчетов</h1>
                                <p class="mbr-text mb-0">
                                    При помощи нашего сервиса можно создать любой вид отчета. Это может быть сводный отчет по оплатам и услугам, по истекающим абонементам или по состоянию лицевых счетов. Возможность формирования оборотно сальдовой ведомости или отчета по остаткам товаров. А также один из самых важных-сводный отчет по проведенным  групповым и индивидуальным тренировкам.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="media-container-row row">
                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__net.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Работа с неограниченным количеством филиалов</h1>
                                <p class="mbr-text mb-0">
                                    Данная программа не ограничивается управлением лишь одного фитнес клуба. Она дает возможность управлять даже целой сетью фитнес центров. Независимо от количества филиалов, контроль и управление осуществляется быстро и эффективно.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__photo.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Клубные карты</h1>
                                <p class="mbr-text mb-0">
                                    Эта программа дает возможность создания клубной карты для каждого клиента, с помощью которой можно легко отследить всю информацию ее владельца. А также создать денежный депозит, заморозить абонемент или использовать несколько видов абонементов и услуг одновременно.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div class="media-container-row row">
                <div class="col-md-6 col-xs-12 col-sm-12">
                    <div class="media-container-row">
                        <div class="mbr-figure">
                            <img src="images/ss__registration.png" alt="Mobirise" media-simple="true"/>
                        </div>
                        <div class="media-content">
                            <div class="mbr-section-text">
                                <h1>Создание тренировочных программ и их анализ</h1>
                                <p class="mbr-text mb-0">
                                    Сервис дает возможность создать индивидуальную тренировочною программу под каждого клиента. Каталог упражнений, который включает почти все существующие упражнения и техники, упростит работу тренера. Данная программа отслеживает прогресс клиента с помощью простых графиков и дает возможность наблюдать за тренировочным процессом в реальном времени.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!--<div class="col-md-6 col-xs-12 col-sm-12">-->
                <!--<div class="media-container-row">-->
                <!--<div class="mbr-figure">-->
                <!--<img src="images/ss__trainer.png" alt="Mobirise" media-simple="true"/>-->
                <!--</div>-->
                <!--<div class="media-content">-->
                <!--<div class="mbr-section-text">-->
                <!--<h1>Учет работы тренеров</h1>-->
                <!--<p class="mbr-text mb-0">-->
                <!--Контроль за качеством работы и загруженностью работы тренеров. Удобная система подсчета бонусов и премий всего несколько кликов</p>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </section>

        <section class="w-100 benefit-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="title">Что дает использование <br>Sport Service?</h1>
                        <h2 class="sub-title">На примере зала с общей численностью<br>
                            активных клиентов 450 человек.</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 col-sm-12 col-xs-12 benefit-item">
                        <div class="mbr-figure">
                            <img src="images/ss__client_management.png" alt="Mobirise" media-simple="true">
                        </div>

                        <div class="media-content">
                            <h1>Учет клиентов</h1>
                            <div class="description">Увеличилось на 30% количество учтенных клиентов</div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12 col-xs-12 benefit-item">
                        <div class="mbr-figure">
                            <img src="images/ss_callback.png" alt="Mobirise" media-simple="true">
                        </div>

                        <div class="media-content">
                            <h1>Работа с клиентом</h1>
                            <div class="description">Увеличение эффективности работы тренеров с клиентами более чем на 70 %</div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12 col-xs-12 benefit-item">
                        <div class="mbr-figure">
                            <img src="images/ss_solve_summer_problem.png" alt="Mobirise" media-simple="true">
                        </div>

                        <div class="media-content">
                            <h1>Решение проблемы сезоности</h1>
                            <div class="description">Поддерживается стабильная клиентская база не взирая на сезоность
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12 col-xs-12 benefit-item">
                        <div class="mbr-figure">
                            <img src="images/ss_solve_accounter_issues.png" alt="Mobirise" media-simple="true">
                        </div>

                        <div class="media-content">
                            <h1>Упрощенная бухгалтерия</h1>
                            <div class="description">
                                Значительное сокращение времени на контроль и ведение бухгалтерии
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="w-100 finalized-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="title">Простая и надежная система <br>автоматизации фитнес клубов</h1>
                        <h2 class="sub-title">Мы работаем с облачными сервисами, <br>что дает высокую производительность и безопасность данных.
                        </h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 button-wrapper">
                        <a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-light">Попробовать сейчас</a>
                    </div>
                </div>
            </div>
        </section>


        <!--<div class="top-right links">-->
        <!--<template v-if="authenticated">-->
        <!--<router-link :to="{ name: 'home' }">-->
        <!--{{ $t('home') }}-->
        <!--</router-link>-->
        <!--</template>-->
        <!--<template v-else>-->
        <!--<router-link :to="{ name: 'login' }">-->
        <!--{{ $t('login') }}-->
        <!--</router-link>-->
        <!--<router-link :to="{ name: 'register' }">-->
        <!--{{ $t('register') }}-->
        <!--</router-link>-->
        <!--</template>-->
        <!--</div>-->

        <!--<div class="text-center">-->
        <!--<div class="title mb-4">-->
        <!--{{ title }}-->
        <!--</div>-->
        <!--<div class="sub-title mb-4">-->
        <!--{{ $t('home_page_subtitle') }}-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Slider, SliderItem } from 'vue-easy-slider';

    export default {
        layout: 'default',

        data: () => ({
            title: window.config.appName,
            list: [
                {
                    coverImage: 'images/cover-slide-01.jpg',
                    title: 'Sport Service',
                    html: '<div class="ss_comment__slider-item"><p>Сервис по управлению фитнес клубом</p></div>  ' +
                    '<div class="ss_button_container__slider-item"><a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-primary">Попробывать сейчас</a></div>'
                },

                {
                    coverImage: 'images/cover-slide-02.jpg',
                    title: 'Персональный тренинг',
                    html: '<div class="ss_comment__slider-item">Создание персональных тренировочных программ ' +
                    '<br/>и анализ их эффективности</div>  ' +
                    '<div class="ss_button_container__slider-item"><a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-primary">Попробывать сейчас</a></div>'
                },

                {
                    coverImage: 'images/cover-slide-03.jpg',
                    title: 'Уникальная CRM',
                    html: '<div class="ss_comment__slider-item">Новая crm программа на рынке фитнес индустрии</div>  ' +
                    '<div class="ss_button_container__slider-item"><a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-primary">Попробывать сейчас</a></div>'
                }
            ]
        }),

        components: {
            Slider,
            SliderItem
        },

        metaInfo () {
            return { title: this.$t('home') }
        },

        computed: mapGetters({
            authenticated: 'authCheck'
        }),

        methods: {
            /**
             * @desc Построение необходимого CSS
             **/
            _buildCSSForSlideItem (index) {
                if (!this.list || (this.list && !this.list[index])) {
                    return {};
                }

                return {
                    'background-image': 'url(' + this.list[index].coverImage + ')',
                    'background-repeat': 'repeat',
                    'background-position': 'right'
                }
            }
        }


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/welcome.vue